<template>
  <div>
    <!-- /.box-header -->
    <section class="content-header" style="height: 50px;">
      <h1 style="float: left;">{{ $root.title}}</h1>
      <input type="button" value="Add Test Data" @click="setTestActivity()" v-if="0>1" />
      <div action="#" method="get" class="sidebar-form searchBox" style="width: 200px; float: right; margin: 0px; border: 1px solid #337ab7;">
        <div class="input-group">
          <input type="text" name="q" class="form-control" placeholder="Search..." v-model="$root.txtSearch" style="height: 27px; background-color: #fff;">
          <div class="input-group-btn">
            <div class="btn btn-flat" style="height: 28px; padding: 4px 6px; background-color: #fff;"><i class="fa fa-search"></i></div>
          </div>
        </div>
      </div>
    </section>
    <div class="box-body">
      <div class="table-responsive">
        <div class="col-sm-12" style="padding-left: 0px; background-color: #ddd; padding-bottom: 10px; border-radius: 5px;">
          <div class="col-sm-2">
            <span>Function:</span>
            <select class="form-control" v-model="currentFunc" style="padding-left: 0px;" @change="loadActivity">
              <option value="All">All</option>
              <option v-for="(func,index) in functions" :value="func">{{ func }}</option>
            </select>
          </div>
          <div class="col-sm-2" style="height: 54px;">
            <input type="button" class="btn btn-success" value="Refresh" style="margin-top: 20px;" @click="loadActivity" />
          </div>
        </div>
        <VueTable :isLoading="isLoading" :columns="columns" :rows="filteredItems" @rowClick="rowClick"></VueTable>
      </div>
      <!-- /.table-responsive -->
    </div>
  </div>
</template>
<script>
  import VueTable from '../components/Table/DataTable.vue'
  import VAButton from '../components/VAButton'
  import VAAlert from '../components/VAAlert.vue'

  import { db, dbStore } from '../firebase'
  export default {
    name: 'Activity',
    components: { VueTable, 'va-alert': VAAlert, 'va-button': VAButton },
    data () {
      return {
        isLoading: false,
        currentFunc: 'All',
        functions: [
          'AddPrinterDone',
          'CheckServerAlive',
          'ClientAlive',
          'ClientLog',
          'ClientRestart',
          'CreateCustomer',
          'CreateSite',
          'DeletePrinterDone',
          'DeleteRefreshPrinters',
          'DownloadClientVersion',
          'GenerateDealerMSI',
          'GetCustomerKey',
          'GetCustomerSettings',
          'GetCustomersByDealerKey',
          'GetDealerKey',
          'GetDealerSettings',
          'GetReportSettings',
          'GetRules',
          'GetSiteKey',
          'GetSitesByCustomerKey',
          'GetSubCollections',
          'LogPrinterProp',
          'NewPendingAlert',
          'RefreshPrinterStarted',
          'RestorePrinterDone',
          'RunReport',
          'SendEmail',
          'SetClientInfo',
          'SetClientUninstall',
          'SetSignal',
          'UncheckServerAlive',
          'UpdateCounters',
          'UpdateSiteName',
          'UploadPrinters',
          'RefreshPrintersArr',
          'LogPrintersArr',
          'CreateAlerts'
        ],
        activities: [],
        columns: [
          { fieldName: 'Logged', sortFieldName: 'LoggedInt', label: 'Date', isSortable: true, isHidden: false, length: 20, width: '140px' },
          { fieldName: 'Method', label: 'Method', isSortable: true, isHidden: false, width: '160px' },
          { fieldName: 'Payload', label: 'Payload', isSortable: true, isHidden: false, isMultiLine: true, length: 500, width: '240px' }
        ]
      }
    },
    created () {
      this.$root.title = 'Activity Log'
      this.loadActivity()
    },
    computed: {
      hasData () {
        return this.filteredItems !== null && this.filteredItems !== undefined && this.filteredItems.length > 0
      },
      filteredItems () {
        const vm = this
        let result = []
        if (vm.$root.txtSearch.length > 0) {
          let txtSearch = vm.$root.txtSearch.trim().toLowerCase()
          try {
            result = vm.activities.filter(function (row) {
              return Object.keys(row).some(function (key) {
                if (String(row[key]).trim().toLowerCase().indexOf(txtSearch) > -1) {
                  return row
                }
              })
            })
          } catch (e) {
            console.log(e)
            result = []
          }
        } else {
          result = vm.activities
        }
        return result
      }
    },
    methods: {
      setTestActivity () {
        console.log('setTestActivity()...')
        const vm = this
        let reqData = { 'A3Black': '0', 'A3Color': '0', 'A4Black': '5136', 'A4Color': '3205', 'BlackTonerLeft': '76.00%', 'ClientNum': '', 'Community': 'public', 'Contact': 'Administrator', 'Copy': '2807', 'CounterStatus': 'Ok', 'CustomerKey': '-Lk2xrl_BsVkFi46s5nR', 'CyanTonerLeft': '24.00%', 'DateDealerCustomerKey': 'UbMCpyGScbhRkNzuEvdf8uUqMgi2_-Lk2xrl_BsVkFi46s5nR_202303280351', 'DateDealerCustomerMacKey': 'UbMCpyGScbhRkNzuEvdf8uUqMgi2_-Lk2xrl_BsVkFi46s5nR_34-9F-7B-A5-AA-58_202303280351', 'DateDealerCustomerSiteKey': 'UbMCpyGScbhRkNzuEvdf8uUqMgi2_-Lk2xrl_BsVkFi46s5nR_-MyCXRbXIlV1hC2dUWUm_202303280351', 'DateDealerCustomerSiteMacKey': 'UbMCpyGScbhRkNzuEvdf8uUqMgi2_-Lk2xrl_BsVkFi46s5nR_-MyCXRbXIlV1hC2dUWUm_34-9F-7B-A5-AA-58_202303280351', 'DateDealerKey': 'UbMCpyGScbhRkNzuEvdf8uUqMgi2_202303280351', 'DateDealerMacKey': 'UbMCpyGScbhRkNzuEvdf8uUqMgi2_34-9F-7B-A5-AA-58_202303280351', 'DateMacKey': '34-9F-7B-A5-AA-58_202303280351', 'DealerCustomerKey': 'UbMCpyGScbhRkNzuEvdf8uUqMgi2_-Lk2xrl_BsVkFi46s5nR', 'DealerCustomerMacKey': 'UbMCpyGScbhRkNzuEvdf8uUqMgi2_-Lk2xrl_BsVkFi46s5nR_34-9F-7B-A5-AA-58', 'DealerCustomerSiteKey': 'UbMCpyGScbhRkNzuEvdf8uUqMgi2_-Lk2xrl_BsVkFi46s5nR_-MyCXRbXIlV1hC2dUWUm', 'DealerCustomerSiteMacKey': 'UbMCpyGScbhRkNzuEvdf8uUqMgi2_-Lk2xrl_BsVkFi46s5nR_-MyCXRbXIlV1hC2dUWUm_34-9F-7B-A5-AA-58', 'DealerKey': 'UbMCpyGScbhRkNzuEvdf8uUqMgi2', 'DealerMacKey': 'UbMCpyGScbhRkNzuEvdf8uUqMgi2_34-9F-7B-A5-AA-58', 'DeviceCode': '', 'Duplex': '132', 'ErrorString': 'idle(3)', 'Fax': '0', 'HostName': '', 'IPAddress': '10.10.188.150', 'IsRefresh': 'Ready', 'Location': '', 'Logged': '2023-03-28 03:51:47', 'LoggedInt': '202303280351', 'MacAddress': '34-9F-7B-A5-AA-58', 'MagentaTonerLeft': '23.00%', 'ModelName': 'Canon MF1127C / C1127iF/i', 'PageCount': '8341', 'PrinterLocation': '', 'PrinterName': 'Canon MF1127C / C1127iF/i', 'PrinterSerial': '3DB24494', 'Scan': '4273', 'SiteKey': '-MyCXRbXIlV1hC2dUWUm', 'Status': 'sleep', 'UID': 'NQWSz66034Xw9lDHeQc7smsYLlR2', 'YellowTonerLeft': '13.00%' }
        let Sender = {
          Method: 'LogPrinterProp',
          Logged: vm.$moment().format('YYYY-MM-DD HH:mm:ss'),
          PrinterMAC: '9C-93-4E-69-AE-C2',
          Payload: JSON.stringify(reqData)
        }

        db.ref('ApiFunctions/LogSender').once('value', (snapLogSender) => {
          var logSender = snapLogSender.val()
          console.log(logSender)
          if (logSender) {
            if (logSender.LogSenderEnabled) {
              // let path = 'LogSenderActivity/' + logSender.LogSenderIndex
              // logSender.LogSenderIndex++
              console.log(logSender.LogSenderIndex)
              dbStore.collection('LogSenderActivity').doc('.' + logSender.LogSenderIndex).set(Sender)
                .then(function (res) {
                  console.log(res)
                  logSender.LogSenderIndex++
                  if (logSender.LogSenderIndex > logSender.LogSenderMaxRows) {
                    logSender.LogSenderIndex = 0
                  }
                  db.ref('ApiFunctions/LogSender/LogSenderIndex').set(logSender.LogSenderIndex)
                })
                .catch(function (err) {
                  console.error(err)
                })
            }
          }
        })
        // let path = 'LogSenderActivity/' + Sender.Method + '/' + Sender.Logged
      },
      rowClick (btn, item) {
        switch (btn) {
          case 'Delete': this.confirmDelete(item); break
          default: break
        }
      },
      confirmDelete (item) {
        const vm = this
        console.log(item)
        vm.$bus.$emit('modal-open', {
          title: 'Delete Message',
          description: 'Are you sure you want to delete message from [' + item.FullName + ']',
          type: 'modal-primary',
          confirmText: 'Delete',
          cancelText: 'Cancel',
          confirmBefore: () => {
          },
          confirmAfter: () => {
            console.log(item)
            const contactRef = db.ref('Contact/' + item['.key'])
            contactRef.remove()
            vm.loadContactsHistory()
          },
          cancelBefore: () => {
          },
          cancelAfter: () => {
          }
        })
      },
      loadActivity () {
        console.log('loadActivity()...')
        const vm = this
        vm.isLoading = true

        let startAtValue = vm.fromDateInt
        let endAtValue = vm.toDateInt

        console.log(startAtValue)
        console.log(endAtValue)
        // let maxLimit = 100
        // maxLimit = 5000
        vm.activities = []
        let logSenderActivityRef = ''
        if (vm.currentFunc === 'All') {
          logSenderActivityRef = dbStore.collection('LogSenderActivity')
        } else {
          logSenderActivityRef = dbStore.collection('LogSenderActivity').where('Method', '==', vm.currentFunc)
        }
        logSenderActivityRef.get().then(function (snapPrinters) {
          console.log('snapPrinters.size = ' + snapPrinters.size)
          if (snapPrinters.size > 0) {
            snapPrinters.forEach(function (result) {
              let row = result.data()
              row['DocID'] = result.id
              vm.activities.push(row)
            })
          }
          vm.isLoading = false
        }).catch(function (err) {
          console.error(err)
          vm.isLoading = false
        })
      }
    }
  }
</script>
<style>
  .searchBox {
    border-radius: 3px;
    overflow: hidden;
    text-overflow: clip;
  }

    .searchBox input[type="text"] {
      color: #666;
      border-top-left-radius: 2px;
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 2px;
    }

    .searchBox .btn {
      color: #999;
      border: 1px solid transparent;
      box-shadow: none;
      border-top-left-radius: 0;
      border-top-right-radius: 2px;
      border-bottom-right-radius: 2px;
      border-bottom-left-radius: 0;
    }
</style>




// WEBPACK FOOTER //
// Activity.vue?1d0043bb